import React, { useEffect, useRef } from "react";

/**
 * Reveal — minimal IntersectionObserver wrapper that fades + lifts children
 * into view on first visibility. Adds class `in` once intersecting.
 */
const Reveal = ({ as: Tag = "div", className = "", delay = 0, children, ...rest }) => {
    const ref = useRef(null);

    useEffect(() => {
        const el = ref.current;
        if (!el) return;
        const obs = new IntersectionObserver(
            (entries) => {
                entries.forEach((e) => {
                    if (e.isIntersecting) {
                        setTimeout(() => el.classList.add("in"), delay);
                        obs.unobserve(el);
                    }
                });
            },
            { threshold: 0.12 }
        );
        obs.observe(el);
        return () => obs.disconnect();
    }, [delay]);

    return (
        <Tag ref={ref} className={`reveal ${className}`} {...rest}>
            {children}
        </Tag>
    );
};

export default Reveal;
